export default {
  pageNavbar: [
    {
      name: "Napęd",
      anchor: "drive"
    },
    {
      name: "Automatyczne tryby jazdy",
      anchor: "automatic-drive"
    },
    {
      name: "Elektryczność",
      anchor: "electric"
    },
    {
      name: "Więcej",
      anchor: "more"
    },
    {
      name: "Inne",
      anchor: "features"
    }
  ],
  headerDesc:
    "W systemach napędu PHEV (Plug-in Hybrid EV - samochody z napędem hybrydowym z możliwością doładowania akumulatora trakcyjnego z zewnętrznego źródła) dokonał się znaczący postęp. W pojazdach z takim napędem montuje się obecnie mocniejsze silniki elektryczne, oszczędniejsze silniki spalinowe oraz bardziej zaawansowane układy zarządzania mocą. Rozwiązania te gwarantują niezrównane wrażenia wynikające z cichej i płynnej pracy podzespołów oraz wysokiego momentu obrotowego.",
  headerMovieDesc: [
    {
      header: "Układ Twin Motor 4WD",
      desc:
        "Dwa silniki elektryczne. Osobne silniki elektryczne przy przedniej i tylnej osi (Twin Motor 4WD) zapewniają doskonałe osiągi. Standardowy układ napędu na cztery koła S-AWC (Super All Wheel Control) dba o doskonałą trakcję w każdych warunkach."
    },
    {
      header: "PDU",
      desc:
        "Te inteligentne moduły sterowania podnoszą efektywność energetyczną i zapewniają optymalne parametry pracy silników elektrycznych dostarczających maksymalny moment obrotowy o wartości przewyższającej osiągi 3-litrowego silnika benzynowego."
    },
    {
      header: "Generator",
      desc:
        "Wysokowydajny generator przekształca moc silnika spalinowego na elektryczność służącą do ładowania akumulatora trakcyjnego oraz dodatkowego zasilania silników elektrycznych w razie potrzeby."
    },
    {
      header: "Nowy silnik o pojemności 2,4 litra",
      desc:
        "Niezwykle wydajny silnik spalinowy pracujący w cyklu Atkinsona, z długim suwem rozprężania (pracy), charakteryzuje się niskim zużyciem paliwa i niską emisją CO₂."
    },
    {
      header: "Układ Twin Motor 4WD",
      desc:
        "Dwa silniki elektryczne. Osobne silniki elektryczne przy przedniej i tylnej osi (Twin Motor 4WD) zapewniają doskonałe osiągi. Standardowy układ napędu na cztery koła S-AWC (Super All Wheel Control) dba o doskonałą trakcję w każdych warunkach."
    },
    {
      header: "EMCU ",
      desc:
        "Te inteligentne moduły sterowania podnoszą efektywność energetyczną i zapewniają optymalne parametry pracy silników elektrycznych dostarczających maksymalny moment obrotowy o wartości przewyższającej osiągi 3-litrowego silnika benzynowego."
    }
  ],
  innovationSubHeader: "Innwacje",
  innovationHeader: "Automatyczne tryby jazdy",
  electricSubHeader: "Elektryczny i hybrydowy",
  electricHeader: "Efektywność jutra dostępna już dziś",
  electricDesc:
    "Innowacyjny system Plug-in Hybrid EV charakteryzuje się wyjątkową efektywnością. Auto jest w stanie naładować się do pełna ze zwykłego gniazdka elektrycznego jak smartfon. Czas ładowania został przemyślany tak, że ładując go w nocy, rano jest gotowy do jazdy.",
  electricButton: "Zobacz wideo",
  advancedSubHeader: "Zaawansowane technologie",
  advancedHeader: "Więcej",
  advancedEasy: "łatwe ładowanie w domu i podróży",
  advancedEasyDesc:
    "W celu naładowania akumulatora trakcyjnego wystarczy podłączyć Eclipse Cross PHEV do domowego gniazdka elektrycznego. Za pomocą pokładowej ładowarki i kabla samochód można naładować na przykład w nocy. Zajmuje to około 6-7 godzin. Można także skorzystać z szybkiej ładowarki na komercyjnej stacji. Ładowanie akumulatora (do 80% pojemności) trwa wówczas tylko 25 minut. Informacja o statusie ładowania jest wyświetlana na zestawie wskaźników.",
  advancedMode: "Tryb EV",
  advancedModeDesc:
    "Po wybraniu trybu EV częstotliwość uruchamiania silnika spalinowego zostanie ograniczona do minimum, a w wielu sytuacjach drogowych kierowca będzie mógł cieszyć się cichą pracą elektrycznego zespołu napędowego.",
  advancedPower: "Wskaźnik poboru mocy",
  advancedPowerDesc:
    "Jaki jest status silnika spalinowego? A elektrycznego? Wskaźnik mocy w przejrzysty i przystępny sposób informuje między innymi o zużyciu energii, działaniu układu odzyskiwania energii czy mocy generowanej przez silnik spalinowy.",
  advancedImages: ["advanced-image-first.jpg", "advanced-image-second.jpg"],
  footerSlider: [
    {
      header: "Wyświetlacz wielofunkcyjny",
      description:
        "Na wyświetlaczu wielofunkcyjnym podawane są różne informacje dotyczące systemu PHEV, takie jak zasięg, wykorzystanie trybu EV oraz przepływ energii.",
      background: "wyswietlacz.jpg"
    },
    {
      header: "Zarządzanie energią",
      description:
        "Efektywne zarządzanie energią pozwala na jednoczesne korzystanie z różnych funkcji wymagających zasilania - w tym klimatyzacji i systemu audio - nawet w czasie ładowania akumulatora. Na ekranie prezentowany jest aktualny przepływ energii, oczekiwany czas ładowania oraz inne przydatne informacje.",
      background: "zarzadzanie-energia.jpg"
    },
    {
      header: "Zarządzanie poziomem naładowania akumulatora",
      description:
        "Tryb SAVE pozwala zachować obecny poziom naładowania baterii, a tryb CHARGE wymusza jej ładowanie z wykorzystaniem silnika spalinowego.",
      background: "zarzadzanie-poziomem.jpg"
    },
    {
      header:
        "łopatki przy kierownicy do sterowania systemem hamowania odzyskowego",
      description:
        "Za pomocą wygodnie ulokowanych łopatek kierowca może wybrać jeden z sześciu poziomów intensywności działania układu odzykiwania energii.",
      background: "lopatki.jpg"
    },
    {
      header: "ŁADOWANIE BATERII",
      description:
        "Jako jedna z nielicznych hybryd plug-in na rynku Eclipse Cross PHEV wyposażony jest w gniazdo CHAdeMO służące do szybkiego ładowania baterii napędowej prądem stałym. Taki proces trwa zaledwie ok. 25 minut i pozwala naładować baterię do 80% jej pojemności. Proces ładowania z domowego gniazdka trwa 6-7 godzin.",
      background: "chademo.jpg"
    },
    {
      header: "Gwarancja spokoju",
      description:
        "Eclipse Cross PHEV to pojazd niezwykle dopracowany i przetestowany w każdych warunkach. Potwierdzeniem najwyższej jakości wykonania jest 5-letnia gwarancja fabryczna z limitem do 100 000 kilometrów. Z kolei bateria trakcyjna, która jest sercem tego elektryczno-hybrydowego SUV-a, podlega 8-letniej gwarancji, a limit kilometrowy wynosi aż 160 000.",
      background: "gwarancja.jpg"
    }
  ]
};
